module.exports = __webpack_public_path__ + "fonts/Inter-100-latin-ext27.2685934.woff2";